"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var epubViewStyles = {
  viewHolder: {
    position: 'relative',
    height: '100%',
    width: '100%'
  },
  view: {
    height: '100%'
  }
};
var _default = epubViewStyles;
exports.default = _default;